import {
	type DefaultMessagesResponse,
	type PlacementMessageFrontendFactory,
	type AnyProps,
	type NoProps,
	type PlacementRenderer,
	type AnyFrontendStage,
	type PlacementBrowserConfig,
} from '@post-office/message-maker-browser/types';

import { createPlacementFrontend } from '@post-office/message-maker-browser/create-placement-frontend';

import { usePlacementApi } from '@post-office/use-placement-api';

import React, { type PropsWithChildren } from 'react';

const placementConfig: PlacementBrowserConfig = {
	placementId: 'jira-nin-meatball-menu-button',
	options: {
		choreographer: {
			isDefaultEnabled: true,
		},
		hideInIsolatedCloud: false,
	},
};

const placement = {
	createFrontend: createPlacementFrontend(placementConfig),
};

export const createFrontend: <U extends AnyProps = NoProps>(
	placementRenderer: PlacementRenderer<
		{
			render: AnyFrontendStage;
		},
		U
	>,
) => PlacementMessageFrontendFactory<
	{
		render: AnyFrontendStage;
	},
	U
> = placement.createFrontend;

export const PlacementFrontend: PlacementMessageFrontendFactory<
	{
		render: AnyFrontendStage;
	},
	{
		children?: React.ReactNode | undefined;
	}
> = createFrontend<PropsWithChildren>((Messages) => ({ children }) => {
	const { data, error, isLoading } = usePlacementApi<DefaultMessagesResponse>('/');

	if (!children) {
		return null;
	}

	if (error || isLoading || !data?.messages?.length) {
		return <>{children}</>;
	}

	const [message] = data.messages;

	return <Messages.render {...message}>{children}</Messages.render>;
});

export type PlacementFrontendProps = {
	children?: React.ReactNode | undefined;
};
